import { style, styleVariants } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

const baseStyles = style({
  display: "inline-block",
  borderRadius: vars.radii.full,
  width: 20,
  height: 20,
  verticalAlign: "middle",
  textAlign: "center",
  lineHeight: "2.1rem",
  color: vars.colors.white,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.xs,
});

export const resultStyles = styleVariants({
  l: [baseStyles, { backgroundColor: vars.colors.result.l }],
  d: [
    baseStyles,
    { backgroundColor: vars.colors.result.d, color: vars.colors.primaryFixed },
  ],
  w: [baseStyles, { backgroundColor: vars.colors.result.w }],
});
